/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Tabs';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        setTimeout(() => {
            this.setHeights();
        }, 10);

        this.$el.on(EVENT.CLICK, '.js-tabs-tab', (event) => this.changeTab(event));
    }

    setHeights() {
        let heights = [];

        this.$el.find('.js-tabs-section').each(function(index, el) {
            heights.push($(el).outerHeight());
        });

        let maxHeight = Math.max.apply(Math, heights);

        this.$el.find('.js-tabs-main').css('height', maxHeight);

        $('.js-scroll').triggerHandler({
            type: 'updateSticky.LocomotiveScroll',
        })
    }

    changeTab(event) {
        event.preventDefault();
        let $target = $(event.currentTarget);
        let section = $target.attr('href');

        // Change tab
        $('.js-tabs-tab.is-current').removeClass('is-current');
        $target.addClass('is-current');

        // Change content
        $('.js-tabs-section.is-current').removeClass('is-current');
        $(section).addClass('is-current');
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
